/**
 * Build a normalized time-overview model from raw table results.
 *
 * Normalizes observation rows and groups projection values into rcp26 / rcp85
 * columns keyed by period label. Helps UI `SimpleTable` (useNewLayout)
 * and PDF renderer `createFactSheetPdf` share the same layout data
 * (avoid duplicated layout logic).
 */
export function buildTimeOverviewTableModel(tableResult = [], nls = {}) {
  // Separate observation and projection data
  const observations = [];
  const projections = new Map();

  (tableResult || []).forEach((item) => {
    const meta = item.meta || {};
    const periodLabel = meta.label || "";
    const avgVal = item.avgTxt || "";

    if (!meta.projection) {
      // Observation data
      observations.push({ period: periodLabel, value: avgVal });
    } else {
      // Projection data
      if (!projections.has(periodLabel)) {
        projections.set(periodLabel, {
          period: periodLabel,
          rcp26: "",
          rcp85: "",
        });
      }
      const row = projections.get(periodLabel);

      if (meta.isRcp26) {
        row.rcp26 = avgVal;
      } else if (meta.isRcp85) {
        row.rcp85 = avgVal;
      }
    }
  });

  // sort observations and projection rows by the numeric start year
  // observations.sort((a, b) => {
  //   const yearA = parseInt(a.period.split("-")[0].replace("_", ""));
  //   const yearB = parseInt(b.period.split("-")[0].replace("_", ""));
  //   return yearA - yearB;
  // });

  // const projectionRows = Array.from(projections.values()).sort((a, b) => {
  //   const yearA = parseInt(a.period.split("-")[0]);
  //   const yearB = parseInt(b.period.split("-")[0]);
  //   return yearA - yearB;
  // });
  const parseYear = (s) => {
    if (!s) return 0;
    const m = s.match(/(\d{4})/);
    return m ? parseInt(m[1], 10) : 0;
  };

  observations.sort((a, b) => parseYear(a.period) - parseYear(b.period));

  const projectionRows = Array.from(projections.values()).sort(
    (a, b) => parseYear(a.period) - parseYear(b.period)
  );

  return {
    observations,
    projectionRows,
    nls: nls || {},
  };
}

export default buildTimeOverviewTableModel;
